import Vue from 'vue'

Vue.mixin({
  methods: {
    successLabel (text) {
      return '<small class="d-inline-flex flex-row align-start text-center success--status"><i class="icon--status"></i><b>' + text + '</b></small>'
    },
    pendingLabel (text) {
      return '<small class="d-inline-flex flex-row align-start text-center pending--status"><i class="icon--status"></i><b>' + text + '</b></small>'
    },
    infoLabel (text) {
      return '<small class="d-inline-flex flex-row align-start text-center info--status"><i class="icon--status"></i><b>' + text + '</b></small>'
    },
    errorLabel (text) {
      return '<small class="d-inline-flex flex-row align-start text-center error--status"><i class="icon--status"></i><b>' + text + '</b></small>'
    },
    warningLabel (text) {
      return '<small class="d-inline-flex flex-row align-start text-center warning--status"><i class="icon--status"></i><b>' + text + '</b></small>'
    },
    inactiveLabel (text) {
      return '<small class="d-inline-flex flex-row align-start text-center inactive--status"><i class="icon--status"></i><b>' + text + '</b></small>'
    },
    notificationLabel (text) {
      return '<small class="d-inline-flex flex-row align-start text-center notification--status"><i class="icon--status"></i><b>' + text + '</b></small>'
    }
  }
})
